import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 9h16v2H4zm0 4h10v2H4z"
}), 'ShortTextTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShortTextTwoTone.js
// module id = 6117
// module chunks = 2